import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import { useSelector } from "react-redux";

export default function useCreateFunction() {
  const { gql } = useObjectRelationGqlRequest();
  const userMe = useSelector(state => state.editor.me);

  const createFunction = async (data, isGlobal = false) => {
    if (!userMe.objectId) {
      throw Error("unable to get me id");
    }

    // create new function object
    const object = await gql.mutation.createObject(
      {
        name: "studio_function",
        isGlobal,
        attributes: data,
      },
      null
    );

    // if not global function, create relation between user and function object
    if (!isGlobal) {
      await gql.mutation.createRelation(
        {
          destId: parseInt(object.id),
          sourceId: parseInt(userMe.objectId),
          type: "studio_function",
        },
        null
      );
    }
    // return attributes
    const attributes = JSON.parse(object.attributes);
    attributes.id = object.id;
    return attributes;
  };

  return {
    createFunction,
  };
}
